import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import CanFrameDecoder from '../components/tools/canFrameDecoder/CanFrameDecoder';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'CAN Raw Frame Decoder & DBC Generator | AUTOXIUM';
const PAGE_DESCRIPTION = 'Decode raw CAN and CAN FD frames into physical signal values with Intel/Motorola bit visualization, then generate, validate and download a DBC file.';

const CanFrameDecoderPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="can-frame-decoder-page">
      <PageHero
        eyebrow="Engineering Utilities / Communication"
        title="CAN Raw Frame Decoder"
        description="Paste raw CAN or CAN FD frames, define one signal per frame, and see the decoded physical value and exact bit layout — then generate a validated DBC file for all frames and download it."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="can-frame-decoder-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <CanFrameDecoder />
          <ToolGuideCta guidePath="/tools/can-frame-decoder/guide" toolName="CAN Raw Frame Decoder" />
        </div>
      </section>
    </div>
  );
};

export default CanFrameDecoderPage;
